module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAAAXNSR0IArs4c6QAAALtJREFUSA1jZAie9J+BAJjitp4h0+g4iirl6ZUMDz4KoohRk8NETcOoadaow0gNzdEQGw0xUkOAVPWDNo0xPtgrSbCAFeL4ysDN9gvF08+/8DH8+ceMIkZNDuPf0xwEHUZNC4k1a9BG5aB1GMuGWzoEQ1df7BmDosA7FHW77qsxfPvNhiJGTQ7jaOuCxOActGls1GEkxiTDaIgNmxBjYWBkOEvIN59+copffyuO0iUCVrB3gXp/E9JLrjwAS7Eqzpqibq8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sweden.png
// module id = 491
// module chunks = 7